import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import css from './messaging-buttons.css'

class MessagingButtons extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showWarning: false,
    }
  }

  handleMouseEnter = () => {
    this.setState({ showWarning: true })
  }

  handleMouseLeave = () => {
    this.setState({ showWarning: false })
  }

  render() {
    const {
      onClickText,
      onClickEmail,
      tier,
      selectedMenuId,
      remainingBlastMessages,
    } = this.props

    const { showWarning } = this.state

    const warningStyles = cx(css.textBox, { [css.show]: showWarning })
    const disabled = remainingBlastMessages < 1 && selectedMenuId === 'all'
    const disabledStyles = cx({ [css.button]: !disabled, [css.disabledButton]: disabled })

    return (
      <div className={css.buttonWrapper}>
        {tier !== 4 && selectedMenuId !== 'all' && (
          <button className={css.button} onClick={onClickText} key="text">
            <span className={css.label}>TEXT LISTED PATIENTS</span>
          </button>
        )}
        <button
          className={disabledStyles}
          onMouseEnter={disabled && this.handleMouseEnter}
          onMouseLeave={disabled && this.handleMouseLeave}
          onClick={!disabled && onClickEmail}
          key="email"
        >
          <span className={css.label}>EMAIL LISTED PATIENTS</span>
        </button>
        <div className={warningStyles}>
          <span>
            {`To send more blast emails to all patients, please contact Support 
            and increase your monthly limit.`}
          </span>
        </div>
      </div>
    )
  }
}

MessagingButtons.propTypes = {
  onClickEmail: PropTypes.func.isRequired,
  onClickText: PropTypes.func.isRequired,
  tier: PropTypes.number,
  selectedMenuId: PropTypes.string,
  remainingBlastMessages: PropTypes.number.isRequired,
}

export default MessagingButtons



// WEBPACK FOOTER //
// ./src/components/PatientGroups/MessagingButtons.js